export const searchStyles = {
  maxWidth: '55%',
  '& .MuiOutlinedInput-input': {
    paddingY: '0.6rem',
  },
  '& .MuiOutlinedInput-root ': {
    paddingLeft: '0.8rem',
  },
  '& .MuiInputBase-root': {
    fontSize: '1.4rem',
  },
  '& input::placeholder': {
    fontSize: '1.4rem',
    lineHeight: 'normal',
  },
  '& fieldset': {
    border: '0.1rem solid #B7C1CC',
    borderRadius: '0.4rem',
  },
};
